import { mediaItems } from '@/mocks/homeData';

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 scroll-mt-16 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 text-xs font-medium text-secondary-700 bg-secondary-100 rounded-full mb-3">视听专区</span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">精彩漫评解说</h2>
          <p className="text-sm text-foreground-500 mt-2 max-w-lg mx-auto">热门漫画深度解析与精彩片段回顾</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {mediaItems.map((item) => (
            <div key={item.id} className="group rounded-lg overflow-hidden bg-background-100 border border-background-200/70 cursor-pointer">
              <div className="relative aspect-video overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => {
                    const target = e.currentTarget;
                    target.style.display = 'none';
                    (target.parentElement as HTMLElement).classList.add('hidden');
                  }}
                />
                <div className="absolute inset-0 bg-black/20 group-hover:bg-black/30 transition-colors flex items-center justify-center">
                  <span className="w-12 h-12 flex items-center justify-center rounded-full bg-background-50/90 text-primary-500 group-hover:bg-primary-500 group-hover:text-background-50 transition-all">
                    <i className="ri-play-fill text-xl"></i>
                  </span>
                </div>
                <div className="absolute bottom-2 right-2 px-2 py-0.5 rounded bg-black/70 text-background-50 text-[10px] font-mono">
                  {item.duration}
                </div>
              </div>
              <div className="p-3 md:p-4">
                <h3 className="font-heading font-bold text-sm text-foreground-900 group-hover:text-secondary-600 transition-colors mb-1 line-clamp-1">{item.title}</h3>
                <p className="text-xs text-foreground-500 line-clamp-2 leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}